import { GET_WHATSAPP_DEVICE_TOKEN, WHATSAPP_DEVICE_TOKEN_REQUEST, WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, GET_WHATSAPP_CUSTOMER_CHECK, DISCONNECT_WHATSAPP_DEVICE_TOKEN } from "../types";

const initialState = {
  whatsappQr: null,
  whatsappCustomer: null,
  loading: false,
  error: null,
};

const whatsappDeviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSAPP_DEVICE_TOKEN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_WHATSAPP_DEVICE_TOKEN: {
      return {
        ...state,
        whatsappQr: action.payload,
        loading: false,
        error: null
      }
    }
    case DISCONNECT_WHATSAPP_DEVICE_TOKEN: {
      return {
        ...state,
        whatsappQr: null,
        loading: false,
        error: null
      }
    }
    case GET_WHATSAPP_CUSTOMER_CHECK: {
      return {
        ...state,
        whatsappCustomer: action.payload,
        loading: false,
        error: null
      }
    }
    case WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default whatsappDeviceReducer;